import type { Suggestion } from "@interfaces";
import { styled, Box, Button, Typography } from "@mui/material";
import { Search } from "@mui/icons-material";

const MostPopularSearchesContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "left",
  width: "100%",
});

const SuggestionButton = styled(Button)(({ theme }) => ({
  display: "flex",
  border: "none",
  background: theme.palette.background.paper,
  padding: "12px 16px",
  width: "100%",
  cursor: "pointer",
  justifyContent: "space-between",
  gap: "16px",
  alignItems: "center",
  borderBottom: "1px solid #eaeaea",
  borderRadius: 0,
  "&:first-of-type": {
    borderRadius: "8px 8px 0 0",
  },
  "&:last-of-type": {
    borderRadius: "0 0 8px 8px",
    borderBottom: "none",
  },
  "&:hover": {
    background: theme.palette.background.disabled,
  },
}));

const SuggestionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textTransform: "capitalize",
}));

const SearchIcon = styled(Search)(({ theme }) => ({
  color: theme.palette.icon.secondary,
}));

interface Props {
  className?: string;
  onItemClick: (item: Suggestion) => void;
  mostSearchedQueries: Suggestion[];
  children?: React.ReactNode;
}

export const MostPopularSearches: React.FC<Props> = ({
  className,
  onItemClick,
  mostSearchedQueries,
  children,
}) => {
  return (
    <MostPopularSearchesContainer className={className}>
      {children
        ? children
        : mostSearchedQueries.map((item: Suggestion, i: number) => (
            <SuggestionButton
              key={`most-popular-search-${i}`}
              onClick={() => onItemClick(item)}
              endIcon={<SearchIcon />}
            >
              <SuggestionTitle variant="body1">{item.text}</SuggestionTitle>
            </SuggestionButton>
          ))}
    </MostPopularSearchesContainer>
  );
};
